import { call, delay, put, takeEvery } from "redux-saga/effects";
import rollNumberActions from "./actions";
import axios, { all } from "axios";
import { API_URL } from "../../utils/constants";
import commonActions from "../common/actions";

const rollNumberSagas = function* () {
  yield all([
    yield takeEvery(
      rollNumberActions.GET_EXAM_DETAILS_WITH_COURSEID,
      getExamDetailsWithCourseid
    ),
    yield takeEvery(rollNumberActions.GET_BATCH_CANDIDATES, getBatchCandidates),
    yield takeEvery(rollNumberActions.GENERATE_ROLL_NUMBER, generateRollNumber),
    yield takeEvery(
      rollNumberActions.GET_DOWNLOAD_ROLL_NO_DATA,
      getDownloadRollNoData
    ),
    yield takeEvery(
      rollNumberActions.RESET_ROLL_NUMBER_GENERATION,
      resetRollNumber
    ),
    yield takeEvery(rollNumberActions.SAVE_ROLL_NUMBER, saveRollNumber),
    yield takeEvery(rollNumberActions.DELETE_ROLL_NUMBER, deleteRollNumber),
    yield takeEvery(rollNumberActions.FETCH_ROLL_NUMBER, fetchRollNumber),
    yield takeEvery(rollNumberActions.RETRY_ROLL_NUMBER, retryRollNumber),
    yield takeEvery(rollNumberActions.GET_ROLL_NUMBER_STATUS, getRollNumberStatus),
  ]);
};

const getBatchCandidates = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/backoffice/rollnumber/${payload?.courseid}/${payload?.batchid}`
      )
    );
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield put({
      type: rollNumberActions.SET_BATCH_CANDIDATES,
      payload: result?.data?.statusCode === 200 ? result?.data?.data : [],
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
  }
};

const getExamDetailsWithCourseid = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/rollnumber/${payload?.courseid}`)
    );
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield put({
      type: rollNumberActions.SET_EXAM_DETAILS_WITH_COURSEID,
      payload:
        result?.data?.statusCode === 200
          ? result?.data?.data
          : {
              batches: [],
              dates: [],
            },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
  }
};
const generateRollNumber = function* (data) {
  const { payload } = data;
  let { startStatusPolling, ...values } = payload;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/backoffice/rollnumber/generaterollnumber`, {
        ...values,
      })
    );
    if (result?.data?.statusCode === 200) {
      payload?.setStatusModalOpen({
        open: true,
        statustext: "Processing...",
      });
      startStatusPolling?.();
    }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });

   
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });

    // yield put({
    //     type: rollNumberActions.SET_BATCH_CANDIDATES,
    //     payload: (result?.data?.statusCode === 200) ? result?.data?.data : []
    // });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
  }
};

const getDownloadRollNoData = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(
        `${API_URL}/backoffice/rollnumber/getrollnumbercandidatedata`,
        payload
      )
    );
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });

    yield put({
      type: rollNumberActions.SET_DOWNLOAD_ROLL_NO_DATA,
      payload: result?.data?.statusCode === 200 ? result?.data?.data : [],
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
  }
};

const resetRollNumber = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/backoffice/rollnumber/resetrollnumber`, payload)
    );
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    if(result?.data?.statusCode === 200){
      yield put({ type: rollNumberActions.SET_DOWNLOAD_ROLL_NO_DATA, payload: [] });
      yield put({ type: rollNumberActions.SET_ROLL_NUMBER_STATUS, payload: null });
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
  }
};
const saveRollNumber = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/backoffice/rollnumber/save`, payload)
    );
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    if (result?.data?.statusCode === 200) {
      // refresh the saved logic so the UI knows generation is now allowed
      yield put({
        type: rollNumberActions.FETCH_ROLL_NUMBER,
        payload: {
          courseid: payload?.courseid,
          examid: payload?.examid,
          batchid: payload?.batchid,
          silent: true,
        },
      });
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: "failed",
        show: true,
        message: err?.response?.data?.message || "Something went wrong",
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  }
};

const deleteRollNumber = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/backoffice/rollnumber/delete`, payload)
    );
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    if (result?.data?.statusCode === 200) {
      yield put({
        type: rollNumberActions.SET_FETCHED_ROLL_NO_DATA,
        payload: [],
      });
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  }
};

const fetchRollNumber = function* (data) {
  const { payload } = data;
  const { silent, ...requestBody } = payload || {};
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/backoffice/rollnumber/fetch`, requestBody)
    );
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield put({
      type: rollNumberActions.SET_FETCHED_ROLL_NO_DATA,
      payload: result?.data?.statusCode === 200 ? result?.data?.data : [],
    });
    // skip the alert when this fetch is a refresh triggered by another action
    if (!silent) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: { status: null, show: false, message: null },
      });
    }
  } catch (err) {
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  }
};

const retryRollNumber = function* (data) {
  const { payload } = data;
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/backoffice/rollnumber/retry`, payload)
    );
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  }
};

const getRollNumberStatus = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/backoffice/rollnumber/status/${payload.courseid}/${payload.examid}/${payload.batchid}`
      )
    );
    yield put({
      type: rollNumberActions.SET_ROLL_NUMBER_STATUS,
      payload: result?.data?.statusCode === 200 ? result?.data?.data : null,
    });
  } catch (err) {}
};

export default rollNumberSagas;
